<template>
  <main>
    <div class="menu">
      <div class="menu_title">
        <img src="../../assets/images/jsal_bt.png" alt="">
      </div>
    </div>
    <div class="case">
      <div class="w">
        <div class="case_title">
          <img :src="list.case.title" alt="">
        </div>

        <div class="list">
          <ul>
            <li v-for="item in list.case.caselist.casemenu" :class="list.selectid==item.id? 'active':''"
                @click="liston(item.id)">
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>

        <div class="case_list">
          <ul
            class="case_pc"
            v-infinite-scroll="load"
            infinite-scroll-disabled="disabled">
            <li v-for="item in list.case.caselist.casecontent" :key="item.id">
              <router-link tag="a" to="" @click.native="caseid(item.id)">
                <div class="case_photo">
                  <div class="case_top">
                    <img class="case_img" :src="item.img"/>
                    <div class="case_bottom">
                      <img src="../../assets/images/search.png" alt="">
                      <p>点击查看</p>
                    </div>
                  </div>
                </div>
                <h6 class="center p_top">{{item.name}}</h6>
                <p class="center f14">{{item.scene}}</p>
              </router-link>
            </li>
          </ul>
          <p v-if="list.loading" class="center"><img src="../../assets/images/jzz.gif" alt="">全力加载中……</p>
          <p v-if="noMore" class="center">没有更多了</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    data() {
      return {
        list: {
          selectid: 101,//选择栏目index
          case: {
            title: require("@/assets/images/bt拷贝.png"),
            caselist: {
              casemenu: [
                {
                  id: 1,
                  name: 'pc端网站'
                },
                {
                  id: 2,
                  name: '手机端网站'
                },
                {
                  id: 3,
                  name: '微信公众号'
                },
                {
                  id: 4,
                  name: '微信小程序'
                },
                {
                  id: 5,
                  name: '软件系统'
                }
              ],
              casecontent: []
            }
          },
          loading: false,
          page: 4,
          sum: 0
        }
      }
    },
    methods: {
      load() {
        this.list.loading = true
        setTimeout(async () => {
          var dt = await this.$axios.post('/api/itemmore', {
            menu: this.list.selectid,
            type: 2,
            amount: 3,
            page: parseInt(this.list.page)+1
          })
          dt.data = JSON.parse(dt.data)
          if (dt.status == 200) {
            if (dt.data.code !== 0) {
              this.$message({
                type: 'info',
                message: dt.data.msg
              });
              return;
            }
          } else {
            alert(dt.statusText)
            return;
          }
          console.log(dt)
          for (var i = 0; i < dt.data.data.data.length; i++) {
            this.list.case.caselist.casecontent.push(dt.data.data.data[i])
          }
          this.list.page = dt.data.data.page
          // console.log(this.list.case.caselist.casecontent)
          this.list.loading = false
        }, 1000)
      },
      // 菜单栏切换
      async liston(index) {
        this.list.selectid = index;
        this.$router.push({
          name: 'webcase', params: {
            id: index + '.html'
          }
        })
        var dt = await this.$axios.post('/api/webcasecut', {
          menu: index
        })
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list.case.caselist.casecontent = dt.data.data.casecontent
        this.list.sum = dt.data.data.sum
      },
      caseid(val) {
        this.$router.push({
          name: 'details', params: {
            id: val + '.html',
            casemenu: this.$route.params.id.split('.')[0]
          }
        })
      },
      //初始化
      async getcase() {
        var dt = await this.$axios.get('/api/webcase')
        dt.data = JSON.parse(dt.data)
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: 'info',
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText)
          return;
        }
        this.list.case.caselist.casemenu = dt.data.data.casemenu
        this.list.case.caselist.casecontent = dt.data.data.casecontent
        this.list.sum = dt.data.data.sum
        this.list.selectid = dt.data.data.casemenu[0].id
        console.log(this.list.case.caselist.casecontent)
      }
    },
    created() {
      this.list.selectid = this.$route.params.id.split('.')[0]
      this.getcase()
    },
    props: [
      'nav_id'
    ],
    computed: {
      noMore() {
        return this.list.case.caselist.casecontent.length >= this.list.sum
      },
      disabled() {
        return this.loading || this.noMore
      },
    },
    watch:{
      $route(to,from){
        this.liston(this.$route.params.id.split('.')[0])
      }
    }
  };
</script>

<style lang="less" scoped>
  .menu {
    width: 100%;
    background: url("../../assets/images/jdan_bj.png") no-repeat;
    background-position: top left;
    background-size: 100% 100%;
    height: 230px;

    .menu_title {
      padding-top: 75px;
      text-align: center;

      img {
        width: 900px;
      }
    }
  }

  .list {
    padding: 60px 0 0 0;

    ul {
      display: flex;
      justify-content: space-around;
    }

    li {
      border-radius: 4px;
      display: inline-block;
      line-height: 40px;
      padding: 0 44px;
      font-size: 16px;
      margin: 1px;
      background: #e6e6e6;
      transition: all 0.5s ease 0s;
      font-size: 14px;

    }

    li:hover {
      cursor: pointer;
      background: #e50012;
      color: #fff;
    }

    .active {
      background: #e50012;
      color: #fff;
    }
  }


  .case {
    width: 100%;
    min-height: 500px;

    .case_title {
      width: 100%;
      text-align: center;
      padding-top: 80px;

      img {
        height: 60px;
      }
    }

    .case_list {
      .case_pc {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 60px;

        li {
          width: 30%;
          padding-bottom: 15px;

          .case_photo {
            width: 100%;
            padding: 10px;
            background: #ddd;
            box-sizing: border-box;

            .case_top {
              height: 230px;
              position: relative;
              overflow: hidden;

              .case_img {
                transition: all 0.5s;
                width: 100%;
                height: auto;
                min-height: 100%;
              }

              .case_bottom {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                text-align: center;
                background: #111;
                opacity: 0;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                box-sizing: border-box;

                img {
                  width: 20%;
                }
              }
            }

            .case_top:hover .case_bottom {
              opacity: 0.7;
            }

            .case_top:hover {
              .case_img {
                transform: scale(1.1);
              }
            }
          }

          h6 {
            font-size: 18px;
            font-weight: bold;
            padding: 15px 8px 8px;
          }

          p {
            font-size: 14px;
            color: #999;
          }
        }

        li:nth-child(3n+2) {
          margin: 0 5%;
        }
      }

      .case_move {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 60px;

        li {
          width: 22%;
          padding-bottom: 15px;
          margin-right: 4%;

          .case_photo {
            width: 100%;
            padding: 10px;
            background: #ddd;
            box-sizing: border-box;

            .case_top {
              height: 400px;

              .case_bottom {
                width: 100%;
                height: 100%;
                text-align: center;
                background: #111;
                opacity: 0;
                color: #fff;
                padding-top: 175px;
                box-sizing: border-box;

                img {
                  width: 20%;
                }
              }
            }

            .case_top:hover .case_bottom {
              opacity: 0.7;
            }

            .case_top:hover {
              background-size: 110% !important;
              transition: all 0.5s;
            }
          }

          h6 {
            font-size: 18px;
            font-weight: bold;
            padding: 15px 8px 8px;
          }

          p {
            font-size: 14px;
            color: #999;
          }
        }

        li:nth-child(4n) {
          margin-right: 0%;
        }
      }

      > p {
        padding: 20px;
        color: #999999;

        img {
          width: 30px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/pc/webcase.vue